// components/InteractiveToastContent.tsx
import React, { useRef } from 'react';
import styled from '@emotion/styled';
import CloseIcon from '../../Icons/CloseIcon';
import { useAppSelector } from '../../../redux/store';
import toast from 'react-hot-toast';
import ChevronRightIcon from '../../Icons/ChevronRightIcon';
import useOutsideClick from '../../../hooks/ui-control/useOutsideClick';

interface Props {
  message: string;
  toastId: string;
  onConfirm?: () => void;
}

const InteractiveToastContent: React.FC<Props> = ({
  message,
  onConfirm,
  toastId,
}) => {
  const { authData } = useAppSelector((state) => state.auth);

  const toastRef = useRef<HTMLDivElement | null>(null);

  useOutsideClick(toastRef, () => {
    toast.dismiss(toastId);
  });

  return (
    <ToastContainer ref={toastRef}>
      <p>{message}</p>
      <p>
        {`To Upgrade your Tier and have access to this action, Head over to `}
        <Confirm
          onClick={() => {
            requestAnimationFrame(() => toast.dismiss(toastId));
            onConfirm?.();
          }}
        >
          Settings
        </Confirm>
        {` > ${
          authData?.tier === 'TIER 1' ? 'Basic Information' : 'Verification'
        }, to upload your ${
          authData?.tier === 'TIER 1' ? 'Gov ID' : 'Verification Information'
        }`}
      </p>{' '}
      <ButtonRow>
        <CancelButton
          onClick={() => requestAnimationFrame(() => toast.dismiss(toastId))}
        >
          <CloseIcon fillColor="none" strokeColor="red" /> Cancel
        </CancelButton>
        <Upgrade
          onClick={() => {
            requestAnimationFrame(() => toast.dismiss(toastId));
            onConfirm?.();
          }}
        >
          Upgrade Now <ChevronRightIcon />
        </Upgrade>
      </ButtonRow>
    </ToastContainer>
  );
};

export default InteractiveToastContent;

// Styled components (same as before)
const ToastContainer = styled.div`
  background-color: white;
  color: black;
  padding: 1rem;
  border-radius: 8px;
  width: 400px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  & > p:nth-of-type(2) {
    font-size: 14px;
  }
`;

const ButtonRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
`;

const Confirm = styled.span`
  color: ${({ theme }) => theme.palette.mainBlue};
  cursor: pointer;
  text-decoration: underline;
`;

const CancelButton = styled.button`
  padding: 3px 10px;
  background: none;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  color: ${({ theme }) => theme.palette.stateColorRed};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid ${({ theme }) => theme.palette.stateColorRed};
  width: 6rem;

  & > svg {
    min-width: 16px;
  }
`;

const Upgrade = styled.div`
  padding: 3px 10px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.palette.mainBlue};
  color: white;
  display: flex;
  justify-content: end;
  font-weight: 400;
  gap: 0.3rem;
  cursor: pointer;
  width: fit-content;
  border: 2px solid ${({ theme }) => theme.palette.mainBlue};

  & svg {
    color: inherit;
    min-width: 16px;
    max-width: 20px;
  }
`;
